/*
 * 消息存档首页 - 右侧 - 全部组件
 * @Author: pwq
 * @Date: 2020-2-18
 * @Last Modified by: pwq
 */
import React, { useEffect, useRef, useState } from "react";
import styled from 'styled-components'
import { Input, DatePicker, Space, Spin } from 'antd'
import File from '../show-type/File';
import Picture from '../show-type/Picture';
import api from '../../apis/pc/conversation/conversation'
import { useUpdateEffect } from "../../hooks/useUpdateEffect";
import ChatLog from "../chat-log/chatLog";
import CloseIcon from "../../img/close.png"
import { scrollToFirstMessage } from "@/pages/conversation/conversation-utils";

const { RangePicker } = DatePicker;
const { Search } = Input;

const SearchBox = styled.div`
  min-width: 320px;
  max-width: 360px;
  border-left: 1px solid #E9E9E9;
  height: 100%;
`
const BoxHeader = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 16px 0 8px 0;
  cursor: pointer;
`
const ButtonItem = styled.div`
  padding: 0 4px;
  height: 24px;
  border: 1px solid #D9D9D9;
  border-radius: 2px;
  color: #D9D9D9;
  margin-right: 8px;
  &.active {
    background: #FC8352;
    color: #fff;
    border: none;
    line-height: 24px;
  }
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #E9E9E9;
  position: relative;
  cursor: pointer;
  .ant-select {
    width: 160px;
    margin-right: 4px;
  }
  .ant-input-group-wrapper {
    margin-right: 4px;
  }
  .ant-input {
    height: 24px;
  }
  .ant-input-search-button {
    height: 24px;
  }
  .date-time {
    width: 71px;
    height: 24px;
    border-radius: 2px;
    border: 1px solid #D9D9D9;
    position: relative;
    .ant-picker.ant-picker-range{
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      &::after{
        display: block;
        content: '日期';
        width: 100%;
        text-align: right;
        white-space: nowrap;
        color: #595959;
      }
    }
  }
  .ant-picker-range-separator {
    display: none
  }
  .ant-picker-input {
    display: none
  }
  .ant-picker.ant-picker-borderless {
    padding: 0;
    width: 100%;
    height: 100%;
  }
`
const Item = styled.div`
  // width: 308px;
  // height: 90%;
  // overflow: scroll;
`
const SearchTime = styled.div`
  color: #BFBFBF;
  padding-top: 16px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`
const NoIime = styled.div`
  color: #BFBFBF;
  text-align: center;
  margin-top: 40px;
`
const DateName = styled.div`
  position: absolute;
  top: 0;
  right: 8px;
  white-space: nowrap;
  color: #595959;
`
const TimeClose = styled.img`
  width: 12px;
  height: 12px;
  margin-left: 8px;
`

const AllContent = (props) => {
  const { session, handleChange, handleClear } = props;

  const [type, setTabType] = useState(1); // 默认选中全部
  const [condition, setCondition] = useState({ pageSize: 50, pageType: 1, messageType: 1, pageNum: 1 });
  const [chatlist, setChatList] = useState({ list: [] });
  const [isShowCloseIcon, setClose] = useState(true); // 是否展示清除时间的icon
  const [locationInfo, setLocationInfo] = useState('')
  const [loading, setLoading] = useState(false)

  const dataRef = useRef({ top: 0, conditionTimeParams: {} }).current

  useEffect(() => {
    getSearchMessage();
  }, [])
  useUpdateEffect(() => {
    setCondition(condition)
    getSearchMessage();
  }, [condition])

  const getSearchMessage = () => {
    if (!session.sessionId) return;
    let params = {
      sessionId: session.sessionId,
      messageType: condition.messageId ? 1 : type,
      ...condition,
      extendUserId: props.extendUserId,
      uid: props.uid
    }

    if (props.uid) {
      delete params.extendUserId
    } else {
      delete params.uid
    }
    setLoading(true)
    api.chatSearch(params).then(res => {
      const cloneCondition = JSON.parse(JSON.stringify(condition));
      // 都为true时 从未选择时间到选择时间 表示发生了时间的选择 这个时候要设置top 为顶部 滚动到最顶部
      const isChangeTime = [
        condition?.startTime,
        condition?.endTime,
        !dataRef?.conditionTimeParams?.startTime,
        !dataRef?.conditionTimeParams?.endTime,
      ].every((item) => Boolean(item));
      if (res?.code !== 0) return;
      // pageType为1表示初始，2表示下拉，3表示向上加载
      // 老的3的逻辑依旧保留
      if (condition.pageType === 3) {
        let temp = res.data.list.concat(chatlist.list);
        setChatList({ ...res.data, list: temp });
      } else if (condition.pageNum === 1) {
        setChatList(res.data);
      } else {
        // 老逻辑排序有问题 -倒叙展示后2-3逻辑替换
        // 选择时间后 正序展示 同时定位到最早的消息
        let temp = [...chatlist.list, ...res?.data?.list];
        setChatList({ ...res.data, list: temp });
      }
      setTimeout(() => {
        if (isChangeTime) {
          cloneCondition.top = 1;
        }
        dataRef.conditionTimeParams = {
          startTime: params.startTime || '',
          endTime: params.endTime || '',
        };
        scrollToFirstMessage(cloneCondition, res.data.list, 'all-content');
      }, 0);
    }).finally(() => {
      setLoading(false)
    })
  }

  // 选择日期
  const handleTimeChange = (date, dateString) => {
    setChatList({ list: [] });
    setClose(true)
    setCondition({ ...condition, pageNum: 1, pageType: 1, startTime: dateString?.[0] || '', endTime: dateString?.[1] || '' })
  }
  // 搜索的内容
  const handleSearchValue = (value) => {
    if (!value) {
      handleClear(session)
    }
    condition.content = value
    setCondition({ ...condition })
  }
  // 清除选择的日期
  const handleCloseTime = () => {
    setChatList({ list: [] });
    setCondition({ ...condition, pageNum: 1, pageType: 1, startTime: '', endTime: '' })
    setClose(false)
  }
  const handleType = (itemType) => {
    setLocationInfo(itemType.locationInfo ? itemType.locationInfo : '')
    if (itemType.type === type) return;
    if (locationInfo === 'isLocation') {
      handleClear(session)
    }
    setTabType(itemType.type)
    let parent = document?.querySelector(`#all-content`)
    let scrollDom = parent?.querySelector('.infinite-scroll-component')
    if(scrollDom) {
      // 企微切换类型 scrollTop 保持
      dataRef.top = scrollDom.scrollTop
    }
    setTimeout(() => {
      scrollToFirstMessage({ pageNum: 1, top: dataRef.top }, chatlist.list, 'all-content')
    }, 0)
  }
  const allInfo = (
    <>
      <Wrapper>
        <Search
          placeholder='请输入关键词'
          onSearch={handleSearchValue}
          style={{ width: 200 }}
          maxLength={50}
        />
        <div className='date-time'>
          <RangePicker
            onChange={handleTimeChange}
            inputReadOnly='true'
            value={null}
            bordered={false}
          />
        </div>
      </Wrapper>
      <Spin
        spinning={loading}
        wrapperClassName='spin-center-wrapper'
        indicator={
          <div className='spin-center-content'>
            <span className='ant-spin-dot ant-spin-dot-spin'>
              <i className='ant-spin-dot-item'></i>
              <i className='ant-spin-dot-item'></i>
              <i className='ant-spin-dot-item'></i>
              <i className='ant-spin-dot-item'></i>
            </span>
          </div>
        }
      >
        <Item id='all-content'>
          {condition.startTime && isShowCloseIcon ? (
            <SearchTime>
              {condition.startTime} ~ {condition.endTime}
              <TimeClose src={CloseIcon} onClick={handleCloseTime} />
            </SearchTime>
          ) : null}
          {chatlist.list && chatlist.list.length > 0 ? (
            <ChatLog
              log={chatlist}
              height={220}
              reverse={Boolean(condition?.startTime)}
              loadMore={(params) => {
                setCondition({
                  ...condition,
                  ...params,
                  pageNum: condition.pageNum + 1,
                });
              }}
              // 时间范围内的正序展示且下滑加载更多
              inverse={!condition?.startTime}
              source='search-sidebar'
              handleChange={handleChange}
            />
          ) : (
            <NoIime>暂无记录</NoIime>
          )}
        </Item>
      </Spin>
    </>
  );
  const FileInfo = <File session={session} handleChange={handleChange} handleType={handleType} />
  const PictureInfo = <Picture session={session} />
  const tabTypeArr = [
    {
      type: 1,
      name: '全部',
      content: allInfo,
    },
    {
      type: 2,
      name: '文件',
      content: FileInfo,
    },
    {
      type: 3,
      name: '图片/视频',
      content: PictureInfo,
    },
  ]
  return (
    <SearchBox className="traff-searchBox">
      <BoxHeader className="traff-boxHeader">
        {tabTypeArr.map(item => (
          <ButtonItem key={item.type} className={type === item.type ? 'active' : ''} onClick={() => handleType({ type: item.type })}>{item.name}</ButtonItem>
        ))}
      </BoxHeader>
      {props?.isEmpty ? <div style={{ width: '100%', textAlign: 'center' }}>暂无记录</div> : tabTypeArr[type - 1].content}
    </SearchBox>
  )
}

export default AllContent
